import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ultra-products',
  template: ` <router-outlet></router-outlet> `,
})
export class ProductsComponent implements OnInit {
  constructor() {}

  @Input()
  category: number;

  ngOnInit(): void {}
}
